import React, { useEffect } from 'react';
import { Text } from '@fluentui/react';
import { useNavigate } from 'react-router-dom';
import errorImage from '@/assets/shieldDismiss.png';
import { CardScreen } from './CardScreen';
import { t } from '@/strings/index';
import { logScreenRender } from '@/telemetry/telemetryEvents';

const ErrorScreen: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Log screen view (UserBI only - error screen outside main wizard flow)
    logScreenRender('ErrorScreen');
  }, []);

  const handleBack = () => navigate(-1);

  return (
    <CardScreen
      title={t('api.errorTitle')}
      onBackClick={handleBack}
      logoAltText="Tenant logo"
      showBackButton={false}
    >
      <img src={errorImage} alt="Error icon" className="retry-icon" />
      <Text variant="medium" className="screen-subtitle">
        {t('api.errorBody')}
      </Text>
    </CardScreen>
  );
};

export default ErrorScreen;